import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import binding from '@/components/binding'
import binding_list from '@/pages/binding_list'
import first from '@/components/first'
import imeiDetail from '@/pages/imeiDetail'
import maps from '@/pages/maps'
// import myt from '@/pages/myt'
Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'first',
            component: first,
            meta:{
                title:"微信权限认证"
            }
        },
        {
            path: '/login',
            name: 'login',
            component: login,
            meta:{
                title:"GPS查询"
            }
        },
        {
            path: '/binding',
            name: 'binding',
            component: binding,
            meta:{
                title:"GPS绑定"
            }
        },
        {
            path: '/binding_list',
            name: 'binding_list',
            component: binding_list,
            meta:{
                title:"我的设备"
            }
        },
        {
            path: '/',
            name: 'login',
            component: login,
            meta:{
                title:"GPS查询"
            }
        },
        {
            path: '/imeiDetail',
            name: 'imeiDetail',
            component: imeiDetail,
            meta:{
                title:"GPS详情"
            }
        },
        {
            path: '/maps',
            name: 'maps',
            component: maps,
            meta:{
                title:"车辆定位"
            }
        },
        // {
        //     path: '/myt',
        //     name: 'myt',
        //     component: myt,
        //     meta:{
        //         title:""
        //     }
        // }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js